import React from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getOrdersToSyncCount, getSomethingToSync } from '../VNSyncManager/Selectors'

import { ReactComponent as BackButtonCircle } from '../assets/icons/backArrowCircle.svg'

import styles from './HeaderBar.module.scss'

const HeaderBar = ({ history }) => {
  const onHeaderTap = () => {
    history.push('/orders/device-summary')
  }

  const somethingToSync = useSelector(getSomethingToSync)
  const ordersToSyncCount = useSelector(getOrdersToSyncCount)

  // Get the maximum of the counts to determine if there is anything to sync.
  const displayText = `${ordersToSyncCount} Orders to Sync`

  return somethingToSync ? (
    <div className={styles.headerBar}>
      <div className={styles.text}>{displayText}</div>
      <BackButtonCircle className={styles.arrow} onClick={onHeaderTap} />
    </div>
  ) : null
}

HeaderBar.propTypes = {}

export default withRouter(HeaderBar)
